module.exports = __webpack_public_path__ + "static/media/dark-filter-icon.fe5333ee.svg";